import { Clock, PhoneOff, Calendar, HelpCircle } from "lucide-react";

export default function ProblemSection() {
  const problems = [
    {
      icon: Clock,
      title: "Manual calling wears your team out",
      description:
        "Reps spend hours on calls and follow-ups, get tired, and miss high-quality leads.",
    },
    {
      icon: PhoneOff,
      title: "Inbound calls go unanswered",
      description:
        "Every missed call is a prospect who may not call again.",
    },
    {
      icon: Calendar,
      title: "Demos depend on who is free",
      description:
        "Reps are unavailable, prep is thin, and trust suffers.",
    },
    {
      icon: HelpCircle,
      title: "Deals stall on unknowns",
      description:
        "Budget, decision maker and timeline often stay unclear until late in the process.",
    },
  ];

  return (
    <section className="py-16 lg:py-20 bg-[#F1F5F9] border-b border-slate-200/80">
      <div className="w-full max-w-[1200px] mx-auto px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          {/* Left Column: Heading */}
          <div className="lg:col-span-5">
            <h2 className="text-3xl sm:text-4xl lg:text-[44px] font-extrabold text-slate-900 tracking-tight leading-[1.12]">
              Slow follow-up loses<br />
              the buyers who were<br />
              ready to talk
            </h2>
            <p className="mt-5 text-sm sm:text-base text-slate-500 leading-relaxed max-w-sm">
              Sales teams spend their day chasing leads by phone. The serious buyers wait, and some never hear back.
            </p>
          </div>

          {/* Right Column: 4 Clean Divider-separated Items */}
          <div className="lg:col-span-7 divide-y divide-slate-200">
            {problems.map((item, idx) => {
              const IconComponent = item.icon;
              return (
                <div key={idx} className="flex items-start gap-5 py-6 first:pt-0 last:pb-0">
                  <div className="w-12 h-12 rounded-xl bg-[#FEF3C7] border border-[#FDE68A]/60 flex items-center justify-center shrink-0 text-[#D97706]">
                    <IconComponent className="w-5 h-5" />
                  </div>
                  <div className="space-y-1.5 pt-0.5">
                    <h3 className="text-base sm:text-lg font-bold text-slate-900">
                      {item.title}
                    </h3>
                    <p className="text-sm sm:text-base text-slate-600 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
